import { render, staticRenderFns } from "./ShippingANW.vue?vue&type=template&id=389bb3ce&scoped=true"
import script from "./ShippingANW.vue?vue&type=script&lang=js"
export * from "./ShippingANW.vue?vue&type=script&lang=js"
import style0 from "./ShippingANW.vue?vue&type=style&index=0&id=389bb3ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389bb3ce",
  null
  
)

export default component.exports